import { useModalStore } from '@/shared/lib';
import { GenerateStatementModal } from '../ui';
import type { FileType, GenerateStatementFormValues } from './types';
import type {
  HistoryDateFilter,
  Language,
  OperationFilter,
} from '@/shared/types';

interface Params {
  filter?: OperationFilter;
  dateFilter?: HistoryDateFilter;
  dateFrom?: Date;
  dateTo?: Date;
  fileType?: FileType;
  lang?: Language;
  onBack?: (dateFrom?: Date, dateTo?: Date) => void;
  formValues?: GenerateStatementFormValues;
  statementLink?: string;
}

const useGenerateStatementModal = () => {
  const { showDialogComponent } = useModalStore();

  const openGenerateStatementModal = ({
    filter,
    dateFilter,
    dateFrom,
    dateTo,
    onBack,
    fileType,
    lang,
    formValues,
    statementLink,
  }: Params) => {
    showDialogComponent({
      component: (
        <GenerateStatementModal
          filter={filter || 'all'}
          dateFilter={dateFilter}
          onBack={onBack}
          dateFrom={dateFrom}
          dateTo={dateTo}
          fileType={fileType}
          lang={lang}
          formValues={formValues}
          statementLink={statementLink}
        />
      ),
    });
  };

  return { openGenerateStatementModal };
};

export { useGenerateStatementModal };
